import {
  AiOutlineInstagram,
  AiOutlineLinkedin,
  AiOutlineGithub,
} from "react-icons/ai";

const data = [
  {
    id: 1,
    link: "https://www.instagram.com/vini_ts/",
    icon: <AiOutlineInstagram />,
  },
  {
    id: 2,
    link: "https://www.linkedin.com/in/vinicius-teixeira-saraiva/",
    icon: <AiOutlineLinkedin />,
  },
  { id: 3, link: "https://github.com/vinizer4", icon: <AiOutlineGithub /> },
];

export default data;
